import {ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withPreloading, PreloadAllModules} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';
import {NG_EVENT_PLUGINS} from '@taiga-ui/event-plugins';
import * as Sentry from '@sentry/angular';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {httpObservabilityInterceptor} from './shared/observability/http-observability.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    // Первый роут грузится лениво (быстрее initial paint), а остальные страницы
    // догружаются в фоне после него - переход между auth/registration/verify остаётся мгновенным.
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimations(),
    provideHttpClient(withInterceptors([httpObservabilityInterceptor])),
    NG_EVENT_PLUGINS,
    {provide: ErrorHandler, useValue: Sentry.createErrorHandler()},
    // Инстанцирует TraceService сразу при старте, чтобы трейсинг навигации по роутам
    // начался с первого перехода, а не с первого места, где на сервис кто-то подписался.
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ]
};
